<template>
    <div class="goodandfalse">
        <div class="center-box">
            <div class="item-box" v-for='(item,index) in goodandFalseData' :key='index'>
                <i class="iconfont icon-dianzan"></i>
                <h5 class="caption">{{item.caption}}</h5>
                <p class="title">{{item.center}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'GoodAndFalse',
        data() {
            return {
                goodandFalseData: [
                    {
                        caption: 'Advantages',
                        center: '您可以与潜在客户建立关系，如果您的细分是相关的，人们将需要您的产品和服务；您可以个性化电子邮件，为每个收件人量身定制的电子邮件将提高电子邮件的打开率；您可以通过检查电子邮件的打开率，点击率和  转化次数来估算结果。这些指标使您可以优化工作并使其更好。'
                    },
                    {
                        caption: 'Disadvantages',
                        center: '如果您的邮件列表未正确细分，则不会产生任何结果，您将白白浪费金钱。对您的产品不感兴趣的人不仅会忽略您的电子邮件，甚至还会将其发送到垃圾邮件文件夹。'
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    @import url(../../../font/ifont/iconfont.css);

    .goodandfalse {
        padding: 170px 0 136px 0
    }

    .center-box {
        width: 85.4%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 60px;
        margin: 0 auto;
    }

    .item-box {
        border: 2px solid #333333;
        padding: 0 5% 5%;
        padding-top: 76px;
        min-height: 418px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .iconfont {
        font-size: 58px;
        color: #2488F8;
    }

    .item-box:last-child .iconfont {
        transform: rotateX(180deg);
    }

    .caption {
        font-size: 28px;
        font-weight: bold;
        line-height: 40px;
        color: rgba(51, 51, 51, 1);
        margin: 22px 0 30px 0;
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        color: rgba(51, 51, 51, 1);
        max-width: 631px;
        text-align: center;
    }

    @media(max-width: 995px){
        .goodandfalse {
        padding:0;
    }
        .center-box {
            width:100%;
            grid-template-columns: 1fr;
        }
        .item-box {
        border: none;
        padding:5%;
        min-height: auto;
    }
    .caption {
        font-size: 24px;
        line-height: 142%;
        margin:5% 0;
    }
    }

    /* @media(max-width: 1023px) { 
        .center-box {
            width: 90%;
            grid-template-columns: 1fr;
            grid-row-gap: 8%;
        }

        .iconfont {
            font-size: 150px;
        }

        .caption {
            font-size: 75px;
            line-height: 142.8%;
        }

        .title {
            font-size: 50px;
            line-height: 187.5%;
            max-width: 90%;
        }
        .item-box {
        padding: 5%;
        min-height: 418px;
    }
    .goodandfalse {
        padding: 170px 0 336px 0
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/goodandfalse.vue